import "core-js/modules/es.array.map";
import "core-js/modules/es.string.link";
import * as React from 'react';
import classnames from 'classnames';
import styles from './Socials.scss';
import Link from '../Link';
import Icon from '../Icon';

function Socials(_ref) {
  var socials = _ref.socials;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.socials)
  }, socials.map(function (social) {
    return /*#__PURE__*/React.createElement(Link, {
      key: social.iconName,
      className: styles.socialLink,
      target: "_blank",
      to: social.link
    }, /*#__PURE__*/React.createElement(Icon, {
      size: "extra-large",
      name: social.iconName,
      color: "text-inverted",
      className: styles.icon
    }));
  }));
}

Socials.defaultProps = {
  socials: []
};
export default Socials;